module.exports = __webpack_public_path__ + "img/10.37034312.png";